// extracted by mini-css-extract-plugin
export default {"helperText":"InputWrapper_helperText__eNX5H","co-basic":"InputWrapper_co-basic__7lJgh","co-error":"InputWrapper_co-error__GIzz3"};